import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setExtracoesSelecionadas } from "../../reducers/loteria/loteriaActions";

import { hasPixParam } from "../../utils/getPreTickets";

class CheckBoxGroup extends Component {
  constructor(props) {
    super(props);
  }

  clearState() {
    this.props.setExtracoesSelecionadas([]);
  }

  handleToggle(value, isRadioButton = false) {
    let selected = this.props.selected;
    
    const newSelected = isRadioButton ? [value] 
      : selected.includes(value)
        ? selected.filter((s) => `${s}` !== `${value}`)
        : selected.concat([value]);

    this.props.setExtracoesSelecionadas(newSelected);
    this.props.handleChange(newSelected);
  }

  renderCheckbox(dataArray) {
    let chkElements = dataArray.map((data) => {
      const isChecked = this.props.selected.includes(data.value);
      const isDisabled = false && hasPixParam() && this.props.selected.length && !isChecked;
        
      let classNameModifiers = "";
      if (isChecked) classNameModifiers += " checked";
      else if (isDisabled) classNameModifiers += " disabled";

      return (
        <div className="checkbox" style={{ opacity: isDisabled ? 0.5 : 1, pointerEvents: isDisabled ? "none" : "all" }}>
          <label>
            <div
              style={{ display: "none" }}
              className={`checkbox-div ${classNameModifiers}`}
            >
              {isChecked ? (
                <i className="glyphicon glyphicon-ok"></i>
              ) : (
                <React.Fragment></React.Fragment>
              )}
            </div>
            <input
              checked={isChecked}
              disabled={isDisabled}
              type="checkbox"
              className={this.props.groupName}
              onChange={() => !isDisabled && this.handleToggle(data.value, false)}
            ></input>
            {data.label}
          </label>
        </div>
      );
    });
    return <div>{chkElements}</div>;
  }

  render() {
    return (
      <div className="checkbox-group-div">
        {this.renderCheckbox(this.props.dataArray)}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selected: state.loteria.extracoesSelecionadas,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setExtracoesSelecionadas,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CheckBoxGroup);



// WEBPACK FOOTER //
// ./src/common/form/checkBoxGroup.jsx